// BibleProject "Book of..." video overviews.
// Sourced from official BibleProject playlists:
//   OT: https://www.youtube.com/playlist?list=PLH0Szn1yYNeeVFodkI9J_WEATHQCwRZ0u
//   NT: https://www.youtube.com/playlist?list=PLH0Szn1yYNecanpQqdixWAm3zHdhY2kPR
//
// `book` = display name of the actual book (used for Bible Gateway link + reading tracker).
//         Omitted (null) for high-level "Summary" videos that aren't a single book.
// `trackerKey` = stable key used by the Bible Reading Tracker so combined videos
//                like Genesis Part 1 & Part 2 map to the SAME book.
// The two `Summary` entries share no tracker key (they're not a book).

export const OT_BOOK_VIDEOS = [
  { id: 'ALsluAKBZ-c', title: 'Old Testament Summary', duration: '12:44', book: null, trackerKey: null },
  { id: 'GQI72THyO5I', title: 'Genesis (Part 1)', duration: '7:43', book: 'Genesis', trackerKey: 'genesis' },
  { id: 'F4isSyennFo', title: 'Genesis (Part 2)', duration: '8:08', book: 'Genesis', trackerKey: 'genesis' },
  { id: 'jH_aojNJM3E', title: 'Exodus (Part 1)', duration: '6:33', book: 'Exodus', trackerKey: 'exodus' },
  { id: 'oNpTha80yyE', title: 'Exodus (Part 2)', duration: '6:27', book: 'Exodus', trackerKey: 'exodus' },
  { id: 'IJ-FekWUZzE', title: 'Leviticus', duration: '8:17', book: 'Leviticus', trackerKey: 'leviticus' },
  { id: 'tp5MIrMZFqo', title: 'Numbers', duration: '6:51', book: 'Numbers', trackerKey: 'numbers' },
  { id: 'q5QEH9bH8AU', title: 'Deuteronomy', duration: '7:49', book: 'Deuteronomy', trackerKey: 'deuteronomy' },
  { id: 'JqOqJlFF_eU', title: 'Joshua', duration: '8:48', book: 'Joshua', trackerKey: 'joshua' },
  { id: 'kOYy8iCfIJ4', title: 'Judges', duration: '7:30', book: 'Judges', trackerKey: 'judges' },
  { id: '0h1eoBeR4Jk', title: 'Ruth', duration: '7:12', book: 'Ruth', trackerKey: 'ruth' },
  { id: 'QJOju5Dw0V0', title: '1 Samuel', duration: '7:19', book: '1 Samuel', trackerKey: '1_samuel' },
  { id: 'YvoWDXNDJgs', title: '2 Samuel', duration: '5:57', book: '2 Samuel', trackerKey: '2_samuel' },
  { id: 'bVFW3wbi9pk', title: '1–2 Kings', duration: '8:51', book: '1 Kings', trackerKey: 'kings' },
  { id: 'HR7xaHv3Ias', title: '1–2 Chronicles', duration: '6:29', book: '1 Chronicles', trackerKey: 'chronicles' },
  { id: 'MkETkRv9tG8', title: 'Ezra–Nehemiah', duration: '8:37', book: 'Ezra', trackerKey: 'ezra_nehemiah' },
  { id: 'JydNSlufRIs', title: 'Esther', duration: '9:14', book: 'Esther', trackerKey: 'esther' },
  { id: 'xQwnH8th_fs', title: 'Job', duration: '11:01', book: 'Job', trackerKey: 'job' },
  { id: 'j9phNEaPrv8', title: 'Psalms', duration: '8:59', book: 'Psalms', trackerKey: 'psalms' },
  { id: 'AzmYV8GNAIM', title: 'Proverbs', duration: '8:08', book: 'Proverbs', trackerKey: 'proverbs' },
  { id: 'lrsQ1tc-2wk', title: 'Ecclesiastes', duration: '8:02', book: 'Ecclesiastes', trackerKey: 'ecclesiastes' },
  { id: '4KC7xE4fgOw', title: 'Song of Songs', duration: '6:59', book: 'Song of Solomon', trackerKey: 'song_of_songs' },
  { id: 'd0A6Uchb1F8', title: 'Isaiah (Part 1)', duration: '8:11', book: 'Isaiah', trackerKey: 'isaiah' },
  { id: '_TzdEPuqgQg', title: 'Isaiah (Part 2)', duration: '8:06', book: 'Isaiah', trackerKey: 'isaiah' },
  { id: 'RSK36cHbrk0', title: 'Jeremiah', duration: '7:15', book: 'Jeremiah', trackerKey: 'jeremiah' },
  { id: 'p8GDFPdaQZQ', title: 'Lamentations', duration: '7:17', book: 'Lamentations', trackerKey: 'lamentations' },
  { id: 'R-CIPu1nko8', title: 'Ezekiel (Part 1)', duration: '7:24', book: 'Ezekiel', trackerKey: 'ezekiel' },
  { id: 'SDeCWW_Bnyw', title: 'Ezekiel (Part 2)', duration: '7:13', book: 'Ezekiel', trackerKey: 'ezekiel' },
  { id: '9cSC9uobtPM', title: 'Daniel', duration: '8:54', book: 'Daniel', trackerKey: 'daniel' },
  { id: 'kE6SZ1ogOVU', title: 'Hosea', duration: '7:36', book: 'Hosea', trackerKey: 'hosea' },
  { id: 'zQLazbgz90c', title: 'Joel', duration: '6:49', book: 'Joel', trackerKey: 'joel' },
  { id: 'mGgWaPGpGz4', title: 'Amos', duration: '7:13', book: 'Amos', trackerKey: 'amos' },
  { id: 'i4ogCrEoG5s', title: 'Obadiah', duration: '4:59', book: 'Obadiah', trackerKey: 'obadiah' },
  { id: 'dLIabZc0O4c', title: 'Jonah', duration: '9:01', book: 'Jonah', trackerKey: 'jonah' },
  { id: 'MFEUEcylwLc', title: 'Micah', duration: '6:39', book: 'Micah', trackerKey: 'micah' },
  { id: 'Y30DanA5EhU', title: 'Nahum', duration: '5:07', book: 'Nahum', trackerKey: 'nahum' },
  { id: 'OPMaRqGJPUU', title: 'Habakkuk', duration: '6:48', book: 'Habakkuk', trackerKey: 'habakkuk' },
  { id: 'oFZknKPNvz8', title: 'Zephaniah', duration: '5:10', book: 'Zephaniah', trackerKey: 'zephaniah' },
  { id: 'juPvv_xcX-U', title: 'Haggai', duration: '5:37', book: 'Haggai', trackerKey: 'haggai' },
  { id: '_106IfO6Kc0', title: 'Zechariah', duration: '8:11', book: 'Zechariah', trackerKey: 'zechariah' },
  { id: 'HPGShWZ4Jvk', title: 'Malachi', duration: '7:09', book: 'Malachi', trackerKey: 'malachi' },
];

export const NT_BOOK_VIDEOS = [
  { id: 'Q0BrP8bqj0c', title: 'New Testament Summary', duration: '8:18', book: null, trackerKey: null },
  { id: '3Dv4-n6OYGI', title: 'Matthew (Part 1)', duration: '8:17', book: 'Matthew', trackerKey: 'matthew' },
  { id: 'GGCF3OPWN14', title: 'Matthew (Part 2)', duration: '7:10', book: 'Matthew', trackerKey: 'matthew' },
  { id: 'HGHqu9-DtXk', title: 'Mark', duration: '9:32', book: 'Mark', trackerKey: 'mark' },
  { id: 'XIb_dCIxzr0', title: 'Luke (Part 1)', duration: '8:16', book: 'Luke', trackerKey: 'luke' },
  { id: '26z_KhwNdD8', title: 'Luke (Part 2)', duration: '7:48', book: 'Luke', trackerKey: 'luke' },
  { id: 'G-2e9mMf7E8', title: 'John (Part 1)', duration: '8:46', book: 'John', trackerKey: 'john' },
  { id: 'RUfh_wOsauk', title: 'John (Part 2)', duration: '8:32', book: 'John', trackerKey: 'john' },
  { id: 'CGbNw855ksw', title: 'Acts (Part 1)', duration: '8:16', book: 'Acts', trackerKey: 'acts' },
  { id: 'Z-17KxpjL0Q', title: 'Acts (Part 2)', duration: '8:04', book: 'Acts', trackerKey: 'acts' },
  { id: 'ej_6dVdJSIU', title: 'Romans (Part 1)', duration: '7:47', book: 'Romans', trackerKey: 'romans' },
  { id: '0SVTl4Xa5fY', title: 'Romans (Part 2)', duration: '9:10', book: 'Romans', trackerKey: 'romans' },
  { id: 'yiHf8klCCc4', title: '1 Corinthians', duration: '8:47', book: '1 Corinthians', trackerKey: '1_corinthians' },
  { id: '3lfPK2vfC54', title: '2 Corinthians', duration: '8:38', book: '2 Corinthians', trackerKey: '2_corinthians' },
  { id: 'vmx4UjRFp0M', title: 'Galatians', duration: '9:04', book: 'Galatians', trackerKey: 'galatians' },
  { id: 'Y71r-T98E2Q', title: 'Ephesians', duration: '8:57', book: 'Ephesians', trackerKey: 'ephesians' },
  { id: 'oE9qqW1-BkU', title: 'Philippians', duration: '9:14', book: 'Philippians', trackerKey: 'philippians' },
  { id: 'pXTXlDxQsvc', title: 'Colossians', duration: '9:17', book: 'Colossians', trackerKey: 'colossians' },
  { id: 'No7Nq6IX23c', title: '1 Thessalonians', duration: '7:18', book: '1 Thessalonians', trackerKey: '1_thessalonians' },
  { id: 'kbPBDKOn1cc', title: '2 Thessalonians', duration: '7:11', book: '2 Thessalonians', trackerKey: '2_thessalonians' },
  { id: '7RoqnGcEjcs', title: '1 Timothy', duration: '9:16', book: '1 Timothy', trackerKey: '1_timothy' },
  { id: 'urlvnxCaL00', title: '2 Timothy', duration: '7:46', book: '2 Timothy', trackerKey: '2_timothy' },
  { id: 'PUEYCVXJM3k', title: 'Titus', duration: '8:21', book: 'Titus', trackerKey: 'titus' },
  { id: 'aW9Q3Jt6Yvk', title: 'Philemon', duration: '6:39', book: 'Philemon', trackerKey: 'philemon' },
  { id: '1fNWTZZwgbs', title: 'Hebrews', duration: '8:17', book: 'Hebrews', trackerKey: 'hebrews' },
  { id: 'qn-hLHWwRYY', title: 'James', duration: '8:03', book: 'James', trackerKey: 'james' },
  { id: 'WhP7AZQlzCg', title: '1 Peter', duration: '7:57', book: '1 Peter', trackerKey: '1_peter' },
  { id: 'wWLv_ITyKYc', title: '2 Peter', duration: '8:03', book: '2 Peter', trackerKey: '2_peter' },
  { id: 'l3QkE6nKylM', title: '1–3 John', duration: '9:36', book: '1 John', trackerKey: 'letters_of_john' },
  { id: '6UoCmakZmys', title: 'Jude', duration: '7:45', book: 'Jude', trackerKey: 'jude' },
  { id: '5nvVVcYD-0w', title: 'Revelation (Part 1)', duration: '11:49', book: 'Revelation', trackerKey: 'revelation' },
  { id: 'QpnIrbq2bKo', title: 'Revelation (Part 2)', duration: '11:51', book: 'Revelation', trackerKey: 'revelation' },
];

// Bible Gateway link for a given book (uses ESV by default).
export const bibleGatewayUrl = (book) =>
  `https://www.biblegateway.com/passage/?search=${encodeURIComponent(book)}&version=ESV`;

// Unique tracker rows — one per book, ordered by canonical Bible order.
// Skips high-level Summary entries (trackerKey === null).
export const OT_TRACKER_BOOKS = (() => {
  const seen = new Set();
  const rows = [];
  OT_BOOK_VIDEOS.forEach((v) => {
    if (!v.trackerKey || seen.has(v.trackerKey)) return;
    seen.add(v.trackerKey);
    rows.push({ key: v.trackerKey, name: v.book });
  });
  return rows;
})();

export const NT_TRACKER_BOOKS = (() => {
  const seen = new Set();
  const rows = [];
  NT_BOOK_VIDEOS.forEach((v) => {
    if (!v.trackerKey || seen.has(v.trackerKey)) return;
    seen.add(v.trackerKey);
    rows.push({ key: v.trackerKey, name: v.book });
  });
  return rows;
})();

export const TOTAL_TRACKER_BOOKS = OT_TRACKER_BOOKS.length + NT_TRACKER_BOOKS.length;
